import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-book-open-line',
    title: '海量资源',
    desc: '收录数万部耽美、纯爱、玄幻、都市等各类型漫画，持续更新中',
  },
  {
    icon: 'ri-article-line',
    title: '下拉式阅读',
    desc: '创新的下拉式翻页浏览方式，无需频繁点击，沉浸式追漫体验',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净体验',
    desc: '无弹窗广告干扰，页面简洁清爽，专注漫画阅读本身',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '完美适配电脑、平板与手机，随时随地享受漫画阅读乐趣',
  },
];

export default function FeaturesBanner() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14" aria-labelledby="features-title">
      <div className="text-center mb-8">
        <h2 id="features-title" className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
          为什么选择耽耽漫画
        </h2>
        <p className="text-sm text-foreground-500">致力于打造最优质的漫画阅读平台</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {features.map((feat) => (
          <div
            key={feat.title}
            className="flex flex-col items-center text-center p-5 md:p-6 rounded-lg bg-background-100 hover:bg-primary-50/50 transition-colors duration-200"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mb-3">
              <i className={`${feat.icon} text-accent-600 text-xl`}></i>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1.5">{feat.title}</h3>
            <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}